module.exports = __webpack_public_path__ + "static/media/validate-icon.16b78d09.svg";